import {
  Button,
  Card,
  Col,
  Flex,
  LazyImage,
  Row,
  Shape,
  Title,
  styled,
} from '@teko/ds-desktop';
import {
  BuildPcNumberStepper,
  ProductName,
  ProductPrice,
} from '@teko/ecommerce';
import { ProductCardProps } from '@teko/types/ecommerce';
import { t } from 'i18n';

const StyledCard = styled(Card)`
  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.08);
  }
`;

const NameWrapper = styled(Col)`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  align-items: center;
`;

const Anchor = styled.a`
  color: unset;
  text-decoration: unset;
`;
const SKU = styled.span`
  color: #82869e;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;

const StyledButton = styled(Button)`
  height: 32px;
  width: 105px;
  padding: 0;
`;
const StyledPrice = styled(ProductPrice)`
  min-height: auto;
`;

const StyledTitle = styled(Title)`
  font-size: 16px;
`;

interface IProductCard extends ProductCardProps {
  quantity: number;
}

interface IHamperItemProps {
  title?: string;
  products?: IProductCard[];
  icon?: string;
  onClick?: () => void;
  onIncrease?: (sku: string) => void;
  onDecrease?: (sku: string, quantity: number) => void;
  setQuantity?: (value: number, sku: string) => void;
}

export const HamperItem = ({
  title,
  products = [],
  icon = '',
  onClick,
  onIncrease,
  onDecrease,
  setQuantity,
  ...props
}: IHamperItemProps) => {
  return (
    <StyledCard {...props} padding="s16" marginBottom="s16">
      {title && <StyledTitle>{title}</StyledTitle>}
      {!products.length && (
        <Row marginTop="s12" justify="space-between" align="middle">
          <Shape border="1px solid border" borderRadius="l" padding="s4">
            <LazyImage
              width={68}
              height={68}
              src={icon}
              border
              borderRadius={8}
              contain
            />
          </Shape>
          <StyledButton onClick={onClick} variant="primary">
            {t('Chọn')}
          </StyledButton>
        </Row>
      )}
      {products?.map((product, index) => {
        return (
          <>
            <Row
              key={product.sku}
              width="100%"
              justify="space-between"
              marginTop="s12"
              align="middle"
            >
              <Row width="70%" justify="start">
                <Shape border="1px solid border" borderRadius="l" padding="s4">
                  <LazyImage
                    width={68}
                    height={68}
                    src={product?.imageUrl || icon}
                    onClick={(): void => {
                      if (!product) onClick?.();
                    }}
                    border
                    borderRadius={8}
                    contain
                  />
                </Shape>
                <NameWrapper marginLeft="s12" width="70%">
                  {product ? (
                    <div>
                      <Anchor
                        href={
                          typeof product.link?.as === 'string'
                            ? product.link?.as
                            : (product.link?.as?.pathname as string)
                        }
                        rel="noreferrer noopener"
                        target="_blank"
                      >
                        <ProductName
                          name={
                            product.name || t('Tên sản phẩm đang được cập nhật')
                          }
                        />
                      </Anchor>
                      <SKU>SKU: {product.sellerSku}</SKU>
                    </div>
                  ) : (
                    <div>{t('Vui lòng chọn sản phẩm')}</div>
                  )}
                </NameWrapper>
              </Row>
              {product.quantity && (
                <Row width="30%" justify="end" align="middle">
                  <Flex direction="column" width="60%" height="100%">
                    {product?.quantity && (
                      <BuildPcNumberStepper
                        onIncrease={() => onIncrease?.(product.sku)}
                        onDecrease={() =>
                          onDecrease?.(product.sku, product.quantity)
                        }
                        setValue={(value) => setQuantity?.(value, product.sku)}
                        value={product.quantity}
                      />
                    )}
                  </Flex>
                  <Flex
                    direction="column"
                    justify="start"
                    align="start"
                    width="40%"
                    height="100%"
                  >
                    {product && product.price && (
                      <StyledPrice
                        {...{
                          price: product.price.latestPrice,
                          discount: product.price.discountPercent,
                          listedPrice: product.price.supplierRetailPrice,
                        }}
                      />
                    )}
                  </Flex>
                </Row>
              )}
            </Row>
            {!!product.quantity && index === products.length - 1 && (
              <Row width="100%" justify="end">
                <StyledButton onClick={onClick} variant="primary">
                  {t('Chọn thêm')}
                </StyledButton>
              </Row>
            )}
          </>
        );
      })}
    </StyledCard>
  );
};
